<template>
  <div>
    <div v-if="steps.length" v-loading="loading">
      <div v-for="step in steps" :key="step.id" class="row mb-4">
        <div class="col-12 col-lg-6">
          <ingredient-item-step-image :step="step" />
        </div>
        <div class="col-12 col-lg-6">
          <p><strong>{{ step.sort }}.</strong> {{ step.content }}</p>
          <ingredient-item-step-edit :step="step" @update="getSteps" />
          <ingredient-item-step-delete :stepId="step.id" @delete="getSteps" />
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <p>No usage steps were found.</p>
    </div>
    <section class="my-4">
      <ingredient-item-step-create :ingredientId="$route.params.id" @create="getSteps"/>
    </section>
  </div>
</template>

<script>
import IngredientItemStepCreate from '@/components/Ingredient/Item/IngredientItemStepCreate'
import IngredientItemStepEdit from '@/components/Ingredient/Item/IngredientItemStepEdit'
import IngredientItemStepDelete from '@/components/Ingredient/Item/IngredientItemStepDelete'
import IngredientItemStepImage from '@/components/Ingredient/Item/IngredientItemStepImage'

export default {
  components: {
    IngredientItemStepCreate,
    IngredientItemStepEdit,
    IngredientItemStepDelete,
    IngredientItemStepImage,
  },

  data() {
    return {
      loading: false,
      steps: this.ingredientSteps,
    }
  },

  props: {
    ingredientId: String,
    ingredientSteps: Array,
  },

  methods: {
    async getSteps() {
      this.loading = true
      this.steps = []

      try {
        var { data } = await this.$http.get(`/ingredients/${ this.$route.params.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.steps = data.ingredient.steps
    },
  },
}
</script>
